export default __webpack_public_path__ + "static/media/about02.7a3df034.png";